import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {ScheduleAudience} from '@domain/activity/schedule/schedule.dto';

@Pipe({
  name: 'scheduleAge',
  pure: true
})
export class ScheduleAgePipe implements PipeTransform {

  private readonly transloco = inject(TranslocoService);

  public transform(audience: ScheduleAudience | null): string | null {
    return this.formatAge(audience);
  }

  public formatAge(audience: ScheduleAudience | null): string | null {
    const minAge = audience?.minAge ?? null;
    const maxAge = audience?.maxAge ?? null;
    if (minAge === null && maxAge === null) {
      return null;
    }
    const hasMinAge = minAge !== null;
    const hasMaxAge = maxAge !== null;
    const trKey = hasMinAge && hasMaxAge
      ? 'between'
      : (hasMinAge
        ? 'from'
        : (hasMaxAge
          ? 'until' : 'open'));
    return this.transloco.translate(`activity.item.age.${trKey}`, {
      min: minAge,
      max: maxAge,
    });
  }

}
